import * as yup from 'yup'

const schemaPassword = (isNewUser) =>
  yup.object().shape({
    password: yup
      .string()
      .required('Senha é obrigatória!')
      .when([], {
        is: () => isNewUser,
        then: yup
          .string()
          .min(8, 'A senha deve ter pelo menos 8 caracteres')
          .strongPassword(),
      }),
    passwordConfirmation: yup.string().when([], {
      is: () => isNewUser,
      then: yup
        .string()
        .required('Confirmação de senha é obrigatória!')
        .equalsSibling('password', 'As senhas devem ser iguais'),
      otherwise: yup.string(),
    }),
  })

export default schemaPassword
